import { fmtDate, daysUntilMountain } from "@/lib/ui";

// Days from Mountain-time today to an ISO date; null if unparseable.
function daysUntil(iso) {
  return daysUntilMountain(iso);
}

// At-a-glance Entry Opens On (EOO) + Entry Closes (EC) chips for rodeo cards.
// `dark` switches to the mobile dark-theme palette. EC turns red when it closes
// within 3 days (and hasn't passed yet).
export function EntryChips({ r, dark = false, className = "" }) {
  const open = r.entry_open;
  const close = r.entry_close;
  if (!open && !close) return null;
  const dLeft = daysUntil(close);
  const soon = dLeft !== null && dLeft >= 0 && dLeft <= 3;
  const base = "inline-flex items-center gap-1 text-[11px] font-semibold px-2 py-0.5 rounded";
  const neutral = dark ? "bg-white/5 text-slate-300" : "bg-[#F1F3F5] text-slate-600";
  const soonCls = dark ? "bg-[#C8000F]/20 text-[#F26D77]" : "bg-[#FDE7E9] text-[#C8000F]";
  const lbl = dark ? "text-slate-500" : "text-slate-400";
  return (
    <div className={`flex items-center gap-1.5 flex-wrap ${className}`} data-testid={`entry-chips-${r.id}`}>
      {open && (
        <span className={`${base} ${neutral}`} data-testid={`eoo-chip-${r.id}`}>
          <span className={`font-bold ${lbl}`}>EOO</span> {fmtDate(open)}
        </span>
      )}
      {close && (
        <span className={`${base} ${soon ? soonCls : neutral}`} data-testid={`ec-chip-${r.id}`}>
          <span className={`font-bold ${soon ? "opacity-80" : lbl}`}>EC</span> {fmtDate(close)}
          {soon && <span className="font-bold">· {dLeft === 0 ? "today" : `${dLeft}d`}</span>}
        </span>
      )}
    </div>
  );
}

export default EntryChips;
